// extracted by mini-css-extract-plugin
module.exports = {"container":"logout_container__PwhJD","name":"logout_name__2Em2F"};